import { render } from "./App.vue?vue&type=template&id=295705f8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=295705f8&lang=css"

import exportComponent from "C:\\Users\\iuril\\Documents\\econopro\\mainapp\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__